/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

// @ts-expect-error not migrated to TS yet

// @ts-expect-error not migrated TS yet
import { getIsFreeEmail, getIsStarterEmail } from 'EmailData/selectors/user';
import { navigateTo } from 'EmailData/utils/url';
import { ARCHIVE_EMAIL, CANCEL_EMAIL, EDIT_EMAIL, MOVE_TO_FOLDER, RECEIVE_HAS_ARCHIVED, REQUEST_ARCHIVE_EMAIL, REQUEST_CANCEL_EMAIL, REQUEST_MOVE_TO_FOLDER, REQUEST_UNARCHIVE_EMAIL, UNARCHIVE_EMAIL } from 'EmailData/actions/actionTypes';
import { archive as archiveAPI, cancel as cancelAPI, moveToFolder as moveToFolderAPI, unarchive as unarchiveAPI } from 'EmailData/api/emails';
import ContentRoutes from 'ContentUtils/Routes';
import { getEmailPathById } from 'EmailData/utils/routeUtil';
export function archive(emailId) {
  return dispatch => {
    dispatch({
      type: REQUEST_ARCHIVE_EMAIL
    });
    return archiveAPI(emailId).then(() => {
      dispatch({
        type: ARCHIVE_EMAIL
      });
      dispatch({
        type: RECEIVE_HAS_ARCHIVED,
        payload: true
      });
    }).catch(() => {
      dispatch({
        type: ARCHIVE_EMAIL,
        error: true
      });
    });
  };
}
export function archiveAndCancel(emailId) {
  return dispatch => {
    return dispatch(cancelEmail(emailId)).then(() => dispatch(archive(emailId)));
  };
}
export function cancelEmail(emailId) {
  return dispatch => {
    dispatch({
      type: REQUEST_CANCEL_EMAIL
    });
    return cancelAPI(emailId).then(() => {
      dispatch({
        type: CANCEL_EMAIL
      });
    }).catch(() => {
      dispatch({
        type: CANCEL_EMAIL,
        error: true,
        payload: new Error(`Error canceling email ${emailId}`)
      });
    });
  };
}
export function edit({
  emailId,
  email = null
}) {
  if (!emailId) {
    throw new Error('Missing emailId for edit call');
  }
  return (dispatch, getState) => {
    const isFreeOrStarter = getIsFreeEmail(getState()) || getIsStarterEmail(getState());
    if (email && email.isOptinEmail() && isFreeOrStarter) {
      navigateTo(ContentRoutes.settings('email', 'double-opt-in'));
    } else {
      dispatch({
        type: EDIT_EMAIL
      });
      navigateTo(getEmailPathById(emailId, email, getState()));
    }
  };
}
export function moveToFolder(emailId, folderId) {
  return dispatch => {
    dispatch({
      type: REQUEST_MOVE_TO_FOLDER
    });
    return moveToFolderAPI(emailId, folderId).then(() => {
      dispatch({
        type: MOVE_TO_FOLDER
      });
    }).catch(() => {
      dispatch({
        type: MOVE_TO_FOLDER,
        error: true,
        payload: new Error(`Error moving email ${emailId} to folder ${folderId}`)
      });
    });
  };
}
export function unarchive(emailId) {
  return dispatch => {
    dispatch({
      type: REQUEST_UNARCHIVE_EMAIL
    });
    return unarchiveAPI(emailId).then(() => {
      dispatch({
        type: UNARCHIVE_EMAIL
      });
    }).catch(() => {
      dispatch({
        type: UNARCHIVE_EMAIL,
        error: true,
        payload: new Error(`Error unarchiving email ${emailId}`)
      });
    });
  };
}